import React from 'react'
import { useTranslation } from '@mc/i18n'
import { CHECKOUT_I18N_NAMESPACE } from '../../../../../i18n'
import { Header } from './Header'
import { useTierColumns } from './Table'
import {
  CertificatesFeature,
  DevicesFeature,
  OfflineDownloadFeature,
  PricingFeature,
} from './features'
import classes from './DesktopMatrix.module.scss'

export const DesktopMatrix = () => {
  const { t } = useTranslation(CHECKOUT_I18N_NAMESPACE)
  const selectedColumn = useTierColumns().findIndex(
    ({ isSelected }) => isSelected,
  )

  return (
    <div className={classes.breakout}>
      <div
        aria-label={t('plans.label')}
        role='table'
        className={classes.table}
        style={{ '--selected-column': selectedColumn } as React.CSSProperties}
      >
        {selectedColumn >= 0 && (
          <div
            aria-hidden
            data-testid='selected-column'
            className={classes.selectedColumn}
          />
        )}

        <div role='rowgroup' className={classes.headers}>
          <Header />
        </div>

        <div role='rowgroup' className={classes.body}>
          <PricingFeature />
          <DevicesFeature />
          <OfflineDownloadFeature />
          <CertificatesFeature />
        </div>
      </div>
    </div>
  )
}
